import { CheckboxIcon } from "#icons";

import { boxStyles } from "./Checkbox.styles";

export interface CheckboxIndicatorProps {
  isSelected: boolean;
  isHovered: boolean;
  isFocused: boolean;
}

export function CheckboxIndicator({ isSelected, isHovered, isFocused }: CheckboxIndicatorProps) {
  return (
    <div className={boxStyles({ isSelected, isHovered, isFocused })}>
      {isSelected ? <CheckboxIcon className="text-neutral-white" size={8} /> : null}
    </div>
  );
}
